var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cart-summary" }, [
    _c("h3", { staticClass: "cart-summary__title" }, [
      _vm._v("\n    Total\n  "),
    ]),
    _vm._v(" "),
    _c(
      "dl",
      { staticClass: "cart-summary__totals" },
      [
        _vm.cart.subTotal
          ? [
              _c("dt", [_vm._v("Subtotal")]),
              _vm._v(" "),
              _c("dd", [_vm._v(_vm._s(_vm.cart.subTotal))]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.cart.shipping
          ? [
              _c("dt", [_vm._v("Shipping")]),
              _vm._v(" "),
              _c("dd", [_vm._v(_vm._s(_vm.cart.shipping))]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.cart.discount
          ? [
              _c("dt", [_vm._v("Discount")]),
              _vm._v(" "),
              _c("dd", [
                _c("div", { staticClass: "cart-summary__discount" }, [
                  _vm.cart.discountCode
                    ? _c("span", [
                        _vm._v("(" + _vm._s(_vm.cart.discountCode) + ")"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "close-button",
                    on: { click: _vm.removeDiscount },
                  }),
                ]),
                _vm._v("\n        " + _vm._s(_vm.cart.discount) + "\n      "),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.cart.total
          ? [
              _c("dt", [_vm._v("Total")]),
              _vm._v(" "),
              _c("dd", [_vm._v(_vm._s(_vm.cart.total))]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    !_vm.cart.discountCode
      ? _c(
          "form",
          {
            staticClass: "cart-summary__discount-form",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.addDiscount.apply(null, arguments)
              },
            },
          },
          [
            _c("label", { staticClass: "cart-summary__form-label" }, [
              _vm._v("\n      Apply a discount code to basket total\n    "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cart-summary__discount-form-row" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.discountCode,
                    expression: "discountCode",
                  },
                ],
                attrs: { type: "text", name: "discountCode", required: "" },
                domProps: { value: _vm.discountCode },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.discountCode = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button",
                  class: { "button--disabled": !_vm.discountCode },
                  attrs: { type: "submit", disabled: !_vm.discountCode },
                },
                [_vm._v("\n        Apply\n      ")]
              ),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button button--primary cart-summary__button",
        class: { "button--disabled": !_vm.isValid },
        attrs: { disabled: !_vm.isValid },
        on: { click: _vm.submit },
      },
      [_vm._v("\n    Checkout\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }